interface DomainDropdownItem {
    name: string;
    id: string;
    iconName: string;
    text: string;
    iconColor: string;
}

interface DomainDropdown {
    name: string;
    dropdownItems: DomainDropdownItem[];
}
export interface DomainData {
    Domain: string;
    Favicon: string;
    Clicks: number;
    OriginalClicks: number;
    DesktopClicks: number;
    OrganicClicks: number;
    Share: number;
    DomainShare: number;
    Change: number;
    TopUrl: string;
    Position: number;
    PreviousPosition: number;
    Amp: boolean;
    OrganicRatio: number;
    PaidRatio: number;
    LatestKeywordSerpDate: string;
    SerpFeatures: string[];
    Keywords: string[];
    // Optional fields returned from some endpoints
    Volume?: number;
    Competition?: number;
    Difficulty?: number;
    Cpc?: number;
    TopKeyword?: string;
    PrimaryIntent?: string | null;
    SecondaryIntent?: string | null;
    Children?: DomainData[];
    urls?: DomainDropdown[];
}
export interface IData {
    Data: DomainData[];
}

export const noop: () => void = () => {};

// Enriched table endpoint response types
interface IEnrichRecord extends Partial<DomainData> {
    Volume: number;
    OrganicClicks: number;
    OriginalClicks: number;
    PrimaryIntent: string | null;
    SecondaryIntent: string | null;
}

export interface IEnrichData {
    Data: IEnrichRecord[];
    TotalCount: number;
}

interface UrlTableTransformedRecord extends DomainData {
    urls: DomainDropdown[];
    Share: number;
    Clicks: number;
    selectable: boolean;
    href: string;
    WebSourceShare: number;
    SearchTerm: string;
    SiteSerpFeatures: Record<string, string[]>;
    SerpScrapeDate: string;
    OrganicClicksShare: number;
    totalMonthlyVolume: number;
    totalWindowVolume: number;
    AvgPos: number;
    AvgCompetition?: number;
    AvgDifficulty?: number;
    TopIntent: {
        PrimaryIntent: string | null;
        SecondaryIntent: string | null;
    };
}

export interface UrlTableTransformResult {
    records: UrlTableTransformedRecord[];
    TotalCount?: number;
}
interface IEnrichTransformedRecord extends IEnrichRecord {
    monthlyVolume: number;
    windowVolume: number;
    OrganicClicksShare: number;
    Intent: {
        PrimaryIntent: string | null;
        SecondaryIntent: string | null;
    };
}

export interface IEnrichTransformResult {
    records: IEnrichTransformedRecord[];
    TotalCount: number;
}
